import StartDeliveryButton from './StartDeliveryButton';
import StartChatOrderButton from './StartChatOrderButton';

enum CommerceModalMethod {
  startDelivery = 'start-delivery',
  startChatOrder = 'start-chat-order',
}

const parseTargetUri = (targetUri: string) => {
  try {
    const url = new URL(targetUri, window.location.origin);
    const isModalMode = url.searchParams.get('modal') === 'true';
    const type = url.searchParams.get('type');
    const method = url.searchParams.get('method');

    return {
      isCommerceModal: isModalMode && type === 'commerce',
      method,
      storeOrderId: url.searchParams.get('storeOrderId'),
      buyerId: url.searchParams.get('buyerId'),
    };
  } catch {
    return { isCommerceModal: false, method: null, storeOrderId: null, buyerId: null };
  }
};

interface TemplateUriButtonProps {
  targetUri: string;
  text: string;
  isPrimary: boolean;
  baId: string | null;
  onClick: () => void;
}

const TemplateUriButton = ({ targetUri, text, isPrimary, baId, onClick }: TemplateUriButtonProps) => {
  const parsed = parseTargetUri(targetUri);
  
  if (!parsed.isCommerceModal) {
    return (
      <a
        className={`temp-button ${isPrimary ? 'primary' : ''}`}
        href={targetUri}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
      >
        {text}
      </a>
    );
  }

  switch (parsed.method) {
    case CommerceModalMethod.startDelivery:
      if (!parsed.storeOrderId) return null;
      return (
        <StartDeliveryButton
          storeOrderId={parsed.storeOrderId}
          text={text}
          isPrimary={isPrimary}
          onClick={onClick}
        />
      );

    case CommerceModalMethod.startChatOrder:
      if (!parsed.buyerId || !baId) return null;
      return (
        <StartChatOrderButton
          baId={baId}
          buyerId={parsed.buyerId}
          text={text}
          isPrimary={isPrimary}
          onClick={onClick}
        />
      );

    default:
      return null;
  }
};

export default TemplateUriButton;
